import React from 'react';
import { VerificationOwnership } from './types';

// Optional, mirror-populated-later field, read defensively so we do NOT touch the
// shared mirror types / resolver / plumbing. `ownerVisible` gates the individual
// owner line (privacy default: Club shown, owner hidden until explicitly flagged).
type OwnershipExtras = { ownerVisible?: boolean | null };

interface Props {
  ownership: VerificationOwnership;
}

const Row: React.FC<{ label: string; value: string | null }> = ({ label, value }) =>
  value ? (
    <div className="flex justify-between gap-4 py-1.5">
      <span className="text-sm text-gray-500">{label}</span>
      <span className="text-sm font-medium text-gray-900 text-right">{value}</span>
    </div>
  ) : null;

/**
 * Ownership display. Leads with the Collector Club (the medallion) as the primary
 * identity. The individual owner's name is shown ONLY when the item is flagged
 * `ownerVisible` — otherwise the Club stands in for the owner (privacy default).
 * The node custodian ("Held by") is retained. Null fields are omitted.
 */
const VerifyOwnership: React.FC<Props> = ({ ownership }) => {
  const club = ownership.medallionName || ownership.medallionId;
  const { ownerVisible } = ownership as VerificationOwnership & OwnershipExtras;
  const showOwner = Boolean(ownerVisible) && Boolean(ownership.ownerName);

  return (
    <div className="border-x border-gray-200 px-5 py-4 bg-white">
      <Row label="Collector Club" value={club} />
      {showOwner && <Row label="Owner" value={ownership.ownerName} />}
      {showOwner && ownership.ownerLocation && (
        <Row label="Location" value={ownership.ownerLocation} />
      )}
      <Row label="Held by" value={ownership.holderName} />
    </div>
  );
};

export default VerifyOwnership;
